"use client";

import React from "react";
import { Car, ClipboardCheck, Landmark, Key } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const steps = [{
  title: "Fondazione",
  description: "Nascita del nucleo tecnico specializzato in architetture web per il mercato russo.",
  icon: Landmark
}, {
  title: "Espansione CSI",
  description: "Integrazione dei protocolli di conformità FZ-152 e nodi server locali a Mosca.",
  icon: ClipboardCheck
}, {
  title: "Era Algoritmica",
  description: "Sviluppo di modelli predittivi per il posizionamento Yandex YATI e MatrixNet.",
  icon: Car
}, {
  title: "Leadership B2B",
  description: "Consolidamento come partner strategico per l'export digitale europeo in Russia.",
  icon: Key
}];
export default function TheAutoprimePath() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222460" id="la-nostra-storia-nel-mercato-csi" className="bg-background text-foreground py-24 sm:py-32 relative overflow-hidden">
      <div ref={ref} className={cn("container mx-auto px-4 md:px-6 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        <div className="text-center max-w-2xl mx-auto mb-16 md:mb-20">
          <h2 className="font-default text-3xl md:text-4xl font-bold tracking-tight mb-4 text-foreground uppercase">
            La Nostra Storia nel Mercato CSI
          </h2>
          <p className="text-muted-foreground text-lg font-default">
            Un'evoluzione costante guidata dalla padronanza tecnica e dalla sovranità digitale nel RuNet.
          </p>
        </div>

        {}
        <div className="bg-card/40 border border-white/10 backdrop-blur-md rounded-none p-8 md:p-16 relative shadow-2xl shadow-black/50">
          <div className="relative max-w-5xl mx-auto">
            {}
            <div className="hidden md:block absolute top-8 left-[12%] right-[12%] -translate-y-1/2 z-0">
              <Progress value={100} className="h-[1px] bg-secondary/30" />
            </div>

            {}
            <div className="md:hidden absolute top-8 bottom-8 left-8 w-[1px] bg-secondary/30 z-0" />

            <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-6 relative z-10">
              {steps.map((step, i) => <div key={i} data-index={i} className="flex flex-row md:flex-col items-start md:items-center gap-6 md:gap-5 relative group">
                  {}
                  <div className="shrink-0 size-16 rounded-none border border-secondary bg-background flex items-center justify-center text-secondary shadow-lg shadow-secondary/5 relative z-10 transition-all duration-500 group-hover:scale-105 group-hover:shadow-secondary/40 group-hover:border-primary">
                    <step.icon className="size-7 stroke-[1.5]" />
                  </div>
                  
                  {}
                  <div className="md:text-center pt-2 md:pt-0">
                    <h3 className="font-default text-xl font-semibold mb-2 text-foreground">
                      {step.title}
                    </h3>
                    <p className="text-sm text-muted-foreground leading-relaxed font-default">
                      {step.description}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        <div className="mt-16 text-center">
          <Button asChild size="lg" className="rounded-none px-8 h-12 text-base bg-primary text-primary-foreground hover:bg-primary/90 transition-colors">
            <Link to="/AboutUsPage">Scopri il Nostro Team</Link>
          </Button>
        </div>
      </div>
    </section>;
}